import React from "react";
import { Row, Col, Card } from "react-bootstrap";

const SummaryCards = ({ summary }) => {
    const cards = [
        {
            title: "TOTAL ACCEPTED",
            value: summary.acceptedJobs
        },
        {
            title: "COMPLETED",
            value: summary.completedJobs
        },
        {
            title: "IN PROGRESS",
            value: summary.inProgressJobs
        },
        {
            title: "TOTAL JOBS",
            value: summary.totalJobs
        }
    ];

    return (
        <Row className="mb-4">
            {cards.map((card, index) => (
                <Col md={3} key={index}>
                    <Card className="summary-card">
                        <Card.Body>
                            <h6>{card.title}</h6>
                            <h3>{card.value}</h3>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default SummaryCards;